import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Clock from 'components/clock/clock';
import { Icon } from 'antd';
import ExtendedAvatar from 'components/extendedAvatar/extended-avatar';
import { DocLink, DocPages } from 'components/Help/';

const SiteClock = () => (
  <div className="bhp-quicklinks-item bhp-clock">
    <Clock />
  </div>
);

const HelpDocumentation = () => (
  <div className="bhp-quicklinks-item bhp-icon">
    <DocLink showIcon page={DocPages.contents} />
  </div>
);

const SiteInfo = ({ siteName }) => (
  <div className="bhp-quicklinks-item bhp-site-info">
    <Icon type="team" />
    <div className="bhp-details">
      <div className="bhp-site-title">TENANCY</div>
      <div className="bhp-site-name">{siteName}</div>
    </div>
  </div>
);

SiteInfo.propTypes = {
  siteName: PropTypes.string,
};

SiteInfo.defaultProps = {
  siteName: 'Site Unavailable',
};

const ProfileLink = ({
  name, title, active, onClick
}) => (
  <a className={classNames('bhp-quicklinks-item bhp-profile', { 'bhp-active': active })} onClick={() => onClick()}>
    <ExtendedAvatar name={name} size="small" />
    <div className="bhp-details">
      <div className={classNames('bhp-name', { 'bhp-text-lg': title == null })}>{name}</div>
      {title
      && <div className="bhp-position-title">{title}</div>}
    </div>
  </a>
);

ProfileLink.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func
};

ProfileLink.defaultProps = {
  name: 'Guest',
  title: null,
  active: false,
  onClick() {
  }
};

class QuickLinks extends React.Component {
  static Clock = SiteClock;

  static SiteInfo = SiteInfo;

  static ProfileLink = ProfileLink;

  static HelpDocumentation = HelpDocumentation;

  render() {
    const { children } = this.props;

    return (
      <div className="bhp-quicklinks">
        <div className="bhp-quicklinks-menu">{children}</div>
      </div>
    );
  }
}

QuickLinks.propTypes = {
  children: PropTypes.any.isRequired
};

export default QuickLinks;
